import { FirestoreDataConverter } from "firebase/firestore";
import moment from "moment";
import ImpostoInternacional from "../models/impostoInternacional";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class ImpostoInternacionalDb extends BaseDb<
  ImpostoInternacional,
  { usuarioId: string; impostoId: string }
> {
  _path: string = "usuarios/usuarioId/impostosInternacional/impostoId";

  getConverter(): FirestoreDataConverter<ImpostoInternacional> {
    return {
      fromFirestore: (snapshot) => {
        return new ImpostoInternacional({
          criadoEm: moment(snapshot.get("criadoEm").toDate()),
          dataBase: moment(snapshot.get("dataBase").toDate()),
          resultado: snapshot.get("resultado"),
          abatimentoAnterior: snapshot.get("abatimentoAnterior"),
          abatimento: snapshot.get("abatimento"),
          impostoMensal: snapshot.get("impostoMensal"),
          impostoAnualDevido: snapshot.get("impostoAnualDevido"),
          impostoRetido: snapshot.get("impostoRetido") ?? 0,
          impostoRetidoAno: snapshot.get("impostoRetidoAno") ?? 0,
          impostoCompensavel: snapshot.get("impostoCompensavel") ?? 0,
          impostoEstimadoDIRPF: snapshot.get("impostoEstimadoDIRPF"),
          demonstrativo: snapshot.get("demonstrativo") ?? [],
        });
      },
      toFirestore: (imposto) => toFirestore(imposto),
    };
  }
}